import * as XLSX from "xlsx";

export const getWorksheet = (evt: ProgressEvent<FileReader>, rowsCount?: number) => {
  const arrayBuffer = evt.target?.result as ArrayBuffer;
  const resultArray = new Uint8Array(arrayBuffer);

  /* Read workbook data */
  const workbook = XLSX.read(resultArray, {
    type: "array",
    sheetRows: rowsCount,
  });

  /* Get first worksheet */
  const worksheetName = workbook.SheetNames[0];
  const worksheet = workbook.Sheets[worksheetName];

  return worksheet;
};
